import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import {
  calcColorStatusGeneral,
  cellLineaRazonSocial, cellNotFilter,
  emptyCell, emptyCellOneLevel, EstadoPreventaEnum,
  fnTipoContrato, formatDateWithTimeAMPM, TIPO_FORMA_PAGO_CHOICE,
  TIPO_IDENTIFICACIONES_CHOICE, TIPO_PLANES_CHOICE, TIPO_REFERIDO_PREVENTA_CHOICE,
  TIPO_SERVICIOS_CHOICE,
} from "@/shared"
import { EstadoComponente } from "@/shared/components/ui"
import InfoUser from "@/shared/components/ui/InfoUser/InfoUser"
import { IPreventaPymes } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface"
import { ShowContractsAgendaModal } from "@/erp/operaciones/agendamiento/shared/components/forms"


export const useTableColumnsPreventaPymes = (_estado: EstadoPreventaEnum) => {

  const columnsPreventa = useMemo<MRT_ColumnDef<IPreventaPymes>[]>(() => [
    {
      //id:'razon_social',
      accessorKey: 'cliente_razon_social',
      header: 'Nombre',
      size: 300,
      Cell: ({ row }) => (
        cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_pymes_data.razon_social)
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_pymes_data.identificacion
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      filterVariant: 'select',
      filterSelectOptions: TIPO_IDENTIFICACIONES_CHOICE,
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_pymes_data.tipo_identificacion
      ),
    },
    {
      id:'pyme_enlace',
      accessorKey: 'nombre_pyme_enlace',
      header: 'nombre enlace',
      size: 200,
      Cell: ({ row }) => (
        row.original.coordenadas.map(e => e.nombre).join(',')
      ),
    },

    {
      ...cellNotFilter,
      accessorKey: 'requiere_contrato_fisico',
      header: 'Tipo de Contrato',
      size: 250,
      Cell: ({ row }) => (
        <EstadoComponente
          backgroundColor={fnTipoContrato(
            row.original.pre_requiere_contrato_fisico, row.original.requiere_contrato_fisico).color}
          texto={fnTipoContrato(
            row.original.pre_requiere_contrato_fisico, row.original.requiere_contrato_fisico).texto} />
      ),
    },
    {

      accessorKey: 'estado_aceptacion',
      header: 'Estado Aceptacion',
      filterVariant: 'select',
      filterSelectOptions: [{ label: 'FIRMADO', value: 'true' }, { label: 'PENDIENTE FIRMAR', value: 'false' }],
      size: 200,
      Cell: ({ row }) => (
        <EstadoComponente backgroundColor={row.original.estado_aceptacion ? 'green' : 'orange'} texto={row.original.estado_aceptacion ? 'FIRMADO' : 'PENDIENTE FIRMAR'} />
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'contrato_data_documentos',
      header: 'Documentos',
      Cell: ({ row }) => {
        // Determinar si debe generar automáticamente la autorización
        const debeGenerarAutorizacion = !row.original.url_autorizacion_debito_automatico && !row.original.url_autorizacion_cargo_tarjeta;

        // Obtener el tipo de forma de pago (DÉBITO o TARJETA)
        // Prioridad: forma_pago_data > forma_pago_v2_data
        const tipoFormaPago = row.original.forma_pago_data?.forma_pago || row.original.forma_pago_v2_data?.tipo_pago;

        return (
          <ShowContractsAgendaModal
            razonSocial={cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_pymes_data.razon_social)}
            contrato={row.original.contrato_data!}
            tooltipMessage={"Documentos generados"}
            idPreventa={row.original.id_preventa_pymes}
            showBtnGenDocs={false}
            showBtnCopy={true}
            contratoFisico={row.original.pre_requiere_contrato_fisico || row.original.requiere_contrato_fisico}
            routerOficinaVirtual={'contrato/pymes/'}
            tipoModal={'PYMES'}
            url_autorizacion_debito_automatico={row.original.url_autorizacion_debito_automatico}
            url_autorizacion_cargo_tarjeta={row.original.url_autorizacion_cargo_tarjeta}
            showBtnGenAutorizacion={debeGenerarAutorizacion}
            formaPago={tipoFormaPago}
            urlFirmaDigital={row.original.url_link_firma}
          />
        )
      }
    },
    /*  {
       ...cellNotFilter,
       accessorKey: 'enlace_contrato',
       header: 'Contrato Digital',
       size: 250,
       Cell: ({ row }) => {
         if (row.original.estado_preventa == EstadoPreventaEnum.PENDIENTE_DOCUMENTOS)
           return <>N/A</>
 
         return <>
           {
             (row.original.pre_requiere_contrato_fisico || !row.original.requiere_contrato_fisico) ? (
               <div style={{ justifyContent: 'space-between' }}>
                 {
                   row.original.contrato && (
                     <CopyTextOnClickComponent
                       isButton={true}
                       copyText={`${VITE_API_URL_OFICINA_VIRTUAL}contrato/pymes/${row.original.id_preventa_pymes}`}
                     />
                   )
                 }
               </div>
             ) : 'N/A'
           }
         </>
       }
     }, */
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_pymes_data.celular',
      header: 'Celular',
      size: 200,
    },
    {
      accessorKey: 'celular_2',
      header: 'telefono adicional',
      size: 200,
    },
    {
      accessorKey: 'email',
      header: 'email',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'estado_prospecto',
      header: 'estado',
      size: 200,
      Cell: ({ row }) => (
        row.original.estado_preventa != null ?
          <EstadoComponente backgroundColor={calcColorStatusGeneral(row.original.estado_preventa)} 
          texto={row.original.estado_preventa || ''} /> : null
      ),
    },
    {
      accessorKey: 'motivo_rechazo',
      header: 'Motivo Rechazo',
      size: 200,
      Cell: ({ row }) => (
        emptyCell(row.original.motivo_rechazo_data?.nombre)
      )
    },
    {
      accessorKey: 'observaciones',
      id: 'observacion_cancelar',
      header: 'Observación Cancelación',
      size: 200,
      Cell: ({ row }) => (
        emptyCell(row.original.observaciones?.observacion_cancelar)
      )
    },


    {
      accessorKey: 'tipo_instalacion',
      header: 'tipo instalacion',
      filterVariant: 'select',
      filterSelectOptions: TIPO_REFERIDO_PREVENTA_CHOICE,
      size: 200,
    },
    {
      accessorKey: 'forma_pago',
      header: 'forma pago',
      filterVariant: 'select',
      filterSelectOptions: TIPO_FORMA_PAGO_CHOICE,
      size: 200,
    },
    {
      accessorKey: 'tipo_servicio',
      header: 'tipo_servicio',
      filterVariant: 'select',
      filterSelectOptions: TIPO_SERVICIOS_CHOICE,
      size: 100,
    },
    {
      accessorKey: 'tipo_plan',
      header: 'Tipo Plan',
      filterVariant: 'select',
      filterSelectOptions: TIPO_PLANES_CHOICE,
      size: 100,
    },
    {
      accessorKey: 'valor_plan',
      header: 'valor plan',
      size: 100,
    },

    {
      accessorKey: 'valor_instalacion_total',
      header: 'valor instalacion total',
      size: 100,
    },
    /* {
      ...cellNotFilter,
      accessorKey: 'equipos_adicionales',
      header: 'Equipos adicionales',
      size: 30,
      Cell: ({ row }) => (
        <EquipoAdicionalIconBtnCellModal
          preventa={row.original}
        />
      ),
    }, */
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacion_1',
      header: 'Observacion 1',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacion_2',
      header: 'Observacion 2',
      size: 150,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original.observaciones, 'observacion_2')
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'fecha preventa',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion)
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'Canal Venta',
      size: 200
    },
    {
      accessorKey: 'user_create',
      header: 'Asesor Venta',
      size: 200,
      Cell: ({ row }) => (
        <InfoUser user={row.original.user_create!}
        />
      )
    },
  ], []);

  const columnsPreventaGestionVenta = useMemo<MRT_ColumnDef<IPreventaPymes>[]>(() => [
    {
      accessorKey: 'cliente_razon_social',
      header: 'Nombre',
      size: 200,
      Cell: ({ row }) => (
        cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_pymes_data.razon_social)
      ),
    },
    {
      accessorKey: 'identificacion',
      header: 'Identificacion',
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_pymes_data.identificacion
      ),
    },
    {
      accessorKey: 'motivo_rechazo',
      header: 'Motivo Rechazo',
      size: 250,
      Cell: ({ row }) => (
        <EstadoComponente backgroundColor="red" texto={row.original.motivo_rechazo_data?.nombre ?? 'N/A'}></EstadoComponente>

      )
    },
    {
      accessorKey: 'observaciones.observacion_cancelar',
      header: 'Observación Cancelación',
      size: 300,
      Cell: ({ row }) => (
        emptyCell(row.original.observaciones?.observacion_cancelar)
      )
    },
    {
      ...cellNotFilter,
      accessorKey: 'tipo_identificacion',
      header: 'Tipo Documento',
      filterVariant: 'select',
      filterSelectOptions: TIPO_IDENTIFICACIONES_CHOICE,
      size: 200,
      Cell: ({ row }) => (
        row.original.prospecto_pymes_data.tipo_identificacion
      ),
    },
    /* {
      accessorKey: 'nombre_pyme_enlace',
      header: 'nombre enlace',
      size: 200,
      Cell: ({ row }) => (
        row.original.nombre_pyme_enlace
      ),
    }, */
    {
      ...cellNotFilter,
      accessorKey: 'prospecto_pymes_data.celular',
      header: 'Celular',
      size: 200,
    },
    {
      accessorKey: 'celular_2',
      header: 'telefono adicional',
      size: 200,
    },
    {
      accessorKey: 'email',
      header: 'email',
      size: 200,
    },
    {
      accessorKey: 'tipo_instalacion',
      header: 'tipo instalacion',
      filterVariant: 'select',
      filterSelectOptions: TIPO_REFERIDO_PREVENTA_CHOICE,
      size: 200,
    },
    {
      accessorKey: 'forma_pago',
      header: 'forma pago',
      filterVariant: 'select',
      filterSelectOptions: TIPO_FORMA_PAGO_CHOICE,
      size: 200,
    },
    {
      accessorKey: 'tipo_servicio',
      header: 'tipo_servicio',
      filterVariant: 'select',
      filterSelectOptions: TIPO_SERVICIOS_CHOICE,
      size: 100,
    },
    {
      accessorKey: 'tipo_plan',
      header: 'Tipo Plan',
      filterVariant: 'select',
      filterSelectOptions: TIPO_PLANES_CHOICE,
      size: 100,
    },
    {
      accessorKey: 'valor_plan',
      header: 'valor plan',
      size: 100,
    },

    {
      accessorKey: 'valor_instalacion_total',
      header: 'valor instalacion total',
      size: 100,
    },
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacion_1',
      header: 'Observacion 1',
      size: 150,
    },
    {
      ...cellNotFilter,
      accessorKey: 'observaciones.observacion_2',
      header: 'Observacion 2',
      size: 150,
      Cell: ({ row }) => (
        emptyCellOneLevel(row.original.observaciones, 'observacion_2')
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_creacion',
      header: 'fecha preventa',
      size: 200,
      Cell: ({ row }) => (
        formatDateWithTimeAMPM(row.original.fecha_creacion)
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: 'canal_venta_create',
      header: 'Canal Venta',
      size: 200
    },
  ], []);


  return {
    columnsPreventa,
    columnsPreventaGestionVenta
  }
}